import { render } from "./LevelSelection.vue?vue&type=template&id=1f6f7542"
import script from "./LevelSelection.vue?vue&type=script&lang=js"
export * from "./LevelSelection.vue?vue&type=script&lang=js"

import "./LevelSelection.vue?vue&type=style&index=0&id=1f6f7542&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__